import { AppColors } from "@/assets/colors";
import { AppLinks, pxToRem } from "@/util";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
type props = {
  name: string;
  description: string;
  action: string;
  isAction: boolean;
  nav: string;
};
export default function Header({
  name,
  description,
  action,
  isAction,
  nav = AppLinks.PUBLIC.HOME,
}: Partial<props>) {
  const { classes } = styles();
  return (
    <Box className={classes.featHead}>
      <Typography className={classes.featTxt}>{name}</Typography>
      {description && (
        <Typography className={classes.featDesc}>{description}</Typography>
      )}
      {isAction && (
        <Button
          href={nav}
          variant="contained"
          size="large"
          className={classes.btn}
        >
          {action}
        </Button>
      )}
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  featHead: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    alignItems: "center",
    height: pxToRem(150),
  },
  featTxt: {
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(30),
      textAlign: "center",
    },
    color: AppColors.primary["600"],
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(48),
    marginBottom: pxToRem(-5),
  },
  featDesc: {
    color: AppColors.text.second,
    fontWeight: 400,
    fontSize: pxToRem(20),
    textAlign: "center",
    fontFamily: "General sans",
    lineHeight: "160%",
    letterSpacing: "0%",
    maxWidth: pxToRem(700),
    width: "100%",
    padding: `0 ${pxToRem(16)}`, // add horizontal padding
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(18),
      // width: "90%",
    },
  },
  btn: {
    height: pxToRem(47),
    borderRadius: pxToRem(8),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: pxToRem(50),
      fontSize: pxToRem(20),
    },
  },
}));
